import { AppLinksSelect } from '@atlassian/jira-issue-view-common-views/src/app-link/app-link-select/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import { applinkAuthenticationRequest } from '@atlassian/jira-issue-view-store/src/actions/applink-authentication-actions.tsx';

export default connect(() => ({}), {
	onAuthenticateAppLink: applinkAuthenticationRequest,
})(AppLinksSelect);
